import { useState } from "react";
import { MailCheck, Loader2, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/flowly/infra/Button/Button";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { toast } from "@/lib/toast";

export function VerifyEmail() {
  const [isResending, setIsResending] = useState(false);
  const { user, signOut } = useAuth();
  const { t } = useLanguage();

  const handleResend = async () => {
    if (!user?.email) return;

    setIsResending(true);
    const { error } = await supabase.auth.resend({
      type: "signup",
      email: user.email,
    });

    if (error) {
      toast.error(t.auth.resendError, { description: error.message });
    } else {
      toast.success(t.auth.verificationResent);
    }
    setIsResending(false);
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-card border border-border rounded-lg p-8 shadow-sm max-w-md w-full text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
          <MailCheck className="w-8 h-8 text-primary" />
        </div>

        <div className="space-y-2">
          <h2 className="text-xl font-bold text-foreground">
            {t.auth.verifyEmailTitle}
          </h2>
          <p className="text-muted-foreground text-sm">
            {t.auth.verifyEmailDescription}
          </p>
          {user?.email && (
            <p className="inline-block bg-muted text-muted-foreground text-sm px-3 py-1 rounded-full">
              {user.email}
            </p>
          )}
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleResend}
            variant="primary"
            size="md"
            className="w-full"
            disabled={isResending}
          >
            {isResending ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                {t.auth.resendingEmail}
              </>
            ) : (
              t.auth.resendVerificationEmail
            )}
          </Button>

          <Button
            onClick={signOut}
            variant="secondary"
            size="md"
            className="w-full"
          >
            <LogOut className="w-4 h-4" />
            {t.nav.logout}
          </Button>
        </div>

        <p className="text-muted-foreground text-xs">
          {t.auth.checkSpamFolder}
        </p>
      </div>
    </div>
  );
}
